import { tick } from 'svelte';

/** After a failed submit, takes focus to the first field to fix, so its error is read with it. */
export async function focusFirstInvalid(form: HTMLElement | null | undefined): Promise<void> {
  await tick();
  form?.querySelector<HTMLElement>('[aria-invalid="true"]')?.focus();
}

/** Puts focus back on the control that had it before a request disabled it, unless it has moved on since. */
export async function restoreFocus(previous: Element | null): Promise<void> {
  await tick();
  const lost = document.activeElement === null || document.activeElement === document.body;
  if (lost && previous instanceof HTMLElement && previous.isConnected) previous.focus();
}

/** Focuses a new state's heading so screen readers announce what changed (as the HCP pages do). */
export async function focusHeading(selector = 'main h1'): Promise<void> {
  await tick();
  // SvelteKit resets focus when a navigation finishes, which would undo a focus made as the page first renders.
  await new Promise((resolve) => requestAnimationFrame(resolve));
  const heading = document.querySelector<HTMLElement>(selector);
  if (!heading) return;
  if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
  heading.focus();
}
